export default "__VITE_ASSET__D5e_No9j__"